import StickyHeader from './directives/StickyHeaderDirective';
import PageDrawerSlideoutDirective from './directives/PageDrawerSlideoutDirective';
import MobileHeader from './mobileheader/MobileHeader';

export default angular.module('edge.platform.widgets.pagestructure', []).directive('gwPlStickyHeader', StickyHeader).directive('gwPlPageDrawerSlideout', PageDrawerSlideoutDirective).directive('gwPlMobileHeader', MobileHeader);


//////////////////
// WEBPACK FOOTER
// ./common/js/src/edge/platform/widgets/pagestructure/module.js
// module id = 357
// module chunks = 0